// @flow

import React, { Fragment } from "react";
import type { RaceVideoFeedback } from "@tvg/types/Race";
import buildColor from "@fdr/static-ui/ColorPalette";
import Icon from "@fdr/static-ui/Icons/";

import { Text } from "./styled-components";
import { iconType, videoMessages } from "./constraints";

type OptionsData = {
  feedback: RaceVideoFeedback,
  small?: boolean,
  vertical?: boolean,
  iconSize?: number,
  isReplay?: boolean,
  isShortCopy?: boolean,
  isNightMode?: boolean
};

export default (optionsData: OptionsData) => {
  const options = {
    small: false,
    vertical: false,
    iconSize: 16,
    ...optionsData
  };

  const iconColor = () => {
    if (options.feedback === "STARTING_SOON_NO_REPLAY")
      return buildColor("grey", "D2");
    if (options.isReplay)
      return options.isNightMode
        ? buildColor("white")
        : buildColor("blue", "500");

    return buildColor("white", "100");
  };

  return (
    <Fragment>
      <Icon
        color={iconColor()}
        icon={iconType[options.feedback]}
        size={options.iconSize}
      />
      {!options.small && (
        <Text
          vertical={options.vertical}
          customColor={
            options.isNightMode && options.isReplay && buildColor("white")
          }
        >
          {
            videoMessages[
              options.feedback + (options.isShortCopy ? "_SHORT_COPY" : "")
            ]
          }
        </Text>
      )}
    </Fragment>
  );
};
